import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState, useEffect } from 'react';
import { Button, Tooltip, Popover, PopoverBody } from 'reactstrap';
import clsx from 'clsx';
/**
 * CoreButton is a core button for the library.
 *
 * To add contents like text or icons, simply pass them as children inside the `<CoreButton>` component.
 *
 * @param String label      Used as aria-label for button
 * @param String bsColor    Bootstrap color type for button, see https://reactstrap.github.io/components/buttons/
 * @param Function onClick  Click handler for button
 */

var CoreButton = function CoreButton(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // to manage tooltip state


  var _useState = useState(false),
      tooltipOpen = _useState[0],
      setTooltipOpen = _useState[1];

  var toggle = function toggle() {
    return setTooltipOpen(!tooltipOpen);
  }; // Updates tooltip position when props.tooltip changes


  var _useState2 = useState('right'),
      position = _useState2[0],
      setPosition = _useState2[1];

  useEffect(function () {
    // console.log('tooltip changed')
    if (!!props.tooltip) {
      setPosition(props.tooltip);
    }
  }, [props.tooltip]); // Manage popover state

  var _useState3 = useState(false),
      popoverOpen = _useState3[0],
      setPopoverOpen = _useState3[1];

  var togglePopover = function togglePopover() {
    return setPopoverOpen(!popoverOpen);
  };

  return /*#__PURE__*/React.createElement(Button, _extends({
    id: props.id,
    "aria-label": props.label,
    onClick: props.onClick,
    color: props.color
  }, props, {
    className: clsx('button-core', props.className)
  }), children, props.tooltip && props.tooltip.length > 0 ? /*#__PURE__*/React.createElement(Tooltip, {
    placement: position,
    isOpen: tooltipOpen,
    target: props.id,
    toggle: toggle,
    autohide: props.tooltipAutoHide,
    trigger: "hover"
  }, props.label) : '', props.popover && props.popover.length > 0 ? /*#__PURE__*/React.createElement(Popover, {
    placement: props.popover,
    isOpen: popoverOpen,
    target: props.id,
    toggle: togglePopover
  }, /*#__PURE__*/React.createElement(PopoverBody, {
    dangerouslySetInnerHTML: {
      __html: props.label
    }
  })) : '');
};

CoreButton.defaultProps = {
  label: "",
  onClick: null,
  color: "secondary"
};
export default CoreButton;